import { motion } from 'framer-motion';
import { config } from '../data/config';

interface FilterBarProps {
  selectedTag: string;
  onTagSelect: (tag: string) => void;
  totalCount: number;
  visibleCount: number;
  tags?: string[];
}

export const FilterBar = ({ 
  selectedTag, 
  onTagSelect, 
  totalCount, 
  visibleCount,
  tags = []
}: FilterBarProps) => {
  const availableTags = tags.length > 0
    ? tags
    : config.tags.filter(t => t.id !== 'all').map(t => t.id);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.7 }}
      className="max-w-6xl mx-auto px-6 py-4"
    >
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        {/* Stats */}
        <div className="text-sm text-slate-600">
          <span className="font-semibold">{totalCount}</span> termes •{' '}
          <span className="font-semibold">{visibleCount}</span> affichés
        </div>

        {/* Filtres de tags */}
        <div className="flex flex-wrap justify-center gap-2">
          <button
            onClick={() => onTagSelect('all')}
            className={`
              px-4 py-2 rounded-full text-sm font-medium
              transition-all duration-300
              ${selectedTag === 'all'
                ? 'bg-rose-500 text-white shadow-md scale-105'
                : 'bg-white text-slate-700 hover:bg-slate-50 border border-slate-200 hover:border-rose-300 hover:text-rose-600'
              }
            `}
          >
            Tous
          </button>
          {availableTags.map((tag) => (
            <button
              key={tag}
              onClick={() => onTagSelect(tag)}
              className={`
                px-4 py-2 rounded-full text-sm font-medium
                transition-all duration-300
                ${selectedTag.toLowerCase() === tag.toLowerCase()
                  ? 'bg-rose-500 text-white shadow-md scale-105'
                  : 'bg-white text-slate-700 hover:bg-slate-50 border border-slate-200 hover:border-rose-300 hover:text-rose-600'
                }
              `}
            >
              {tag}
            </button>
          ))}
        </div>
      </div>
    </motion.div>
  );
};
